import React from "react";

function AboutText(props) {
  return <div className="content">{props.text}</div>;
}

export default AboutText;
